export function downloadCanvasPNG(
  canvas: HTMLCanvasElement,
  filename: string,
): void {
  canvas.toBlob((blob) => {
    if (!blob) return;
    downloadBlob(blob, filename);
  }, "image/png");
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // Delay revoke slightly to allow the browser to start the download.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}

export function downloadArrayBufferAsGLB(
  buffer: ArrayBuffer,
  filename: string,
): void {
  const blob = new Blob([buffer], { type: "model/gltf-binary" });
  downloadBlob(blob, filename);
}
